import { Device } from '@goodboydigital/astro';
import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import { Settings } from '../../AppConfig';
import NativeAdPanel from '../../ui/NativeAdPanel';
import { EditorSpriteData } from '../../utils/EditorUtils';
import { CullingComponent } from '../components/CullingComponent';
import { Game } from '../Game';
import { BaseEntity } from './BaseEntity';

export interface NativeAdParams
{
    type: string,
    x: number,
    y: number,
    w: number,
    h: number,
    sx: number,
    sy: number,
    r: number,
    props: {
        content: string
    }
}

export class NativeAdEntity extends BaseEntity
{
    public base: Sprite;
    public params!: NativeAdParams;
    public culling: CullingComponent;
    
    public nativeAdPanel: NativeAdPanel;

    constructor()
    {
        super();
        this.culling = this.addComponent(CullingComponent);
        this.base = new Sprite();
        this.base.anchor.set(0.5);
        this.view.addChild(this.base);
        
        this.nativeAdPanel = new NativeAdPanel();
        this.nativeAdPanel.y -= 35;
        this.view.addChild(this.nativeAdPanel.view);
    }

    public build(params: NativeAdParams): void
    {
        this.params = params;
        this.base.texture = Shared.assets.getTexture('tt-billboard-ad');

        this.base.scale.x = this.params.sx;
        this.base.scale.y = this.params.sy;
        this.base.width = this.params.w;
        this.base.height = this.params.h;
        this.x = this.params.x;
        this.y = this.params.y;
        this.z = -0.33;
        this.culling.updateBounds();
        
        this.view.renderable = false;
    }

    public async hide(): Promise<void>
    {
        this.view.renderable = false;
    }

    public async reveal(): Promise<void>
    {
        if(Settings.isApp() && Device.android){
            this.nativeAdPanel.show();
            this.view.renderable = true;
        }
        
    }
    
    destroy(): void {
        super.destroy();

        if(this.view.renderable){
            this.nativeAdPanel.hide();
        }
        
    }
}

export class NativeAdPanelFactory
{
    public static match(data: EditorSpriteData): boolean
    {
        return data.img !== undefined && data.img.startsWith('nativead');
    }

    public static create(game: Game, params: Partial<NativeAdParams>, reveal: boolean = false): void
    {
        const nativeAd = game.pool.get(NativeAdEntity) as NativeAdEntity;
        const w = 920 * 0.5;
        const h = 700 * 0.5;

        nativeAd.build({
            type: 'SpriteEntity',
            x: 0,
            y: 0,
            w, h,
            sx: 1,
            sy: 1,
            r: 0,
            props: { content: 'accelerate' },
            ...params,
        });
        game.level.addEntity(nativeAd);

        nativeAd.reveal();
    }

}
